import React from "react";
import CricketPage from "./exchange/member/CricketPage";
import { useGetCricketMatchesQuery } from "../../store/services/mainApi";
import Loader from "../components/Loader";
import Error from "../components/Error";

const PrivateCricketScreen = () => {
  // const { data, isFetching, error } = useGetCricketMatchesQuery();
  // if (isFetching) {
  //   return <Loader />;
  // }
  // if (error) {
  //   return <Error />;
  // }
  // console.log(data);

  return (
    <div>
      <CricketPage
      // activeApi={[{ title: "Cricket", active: true }]}
      // activeName="Cricket"
      // cricketMatch={data}
      />
    </div>
  );
};

export default PrivateCricketScreen;
